module.exports = __webpack_public_path__ + "static/media/steelwirebuckle.f4124153.png";